import { Menu, X } from "lucide-react";

/**
 * Mobile menu button component with consistent styling
 * @param {{isOpen: boolean, onToggle: Function, className?: string}} props
 * @returns {JSX.Element} Mobile menu toggle button
 */
export default function MobileMenuButton({ isOpen, onToggle, className = "" }) {
  return (
    <button
      className={`lg:hidden fixed top-4 left-4 z-mobile-menu p-2 bg-card text-foreground rounded-lg shadow-md border border-border ${className}`}
      onClick={onToggle}
      data-testid='button-mobile-menu'>
      {isOpen ? <X size={20} /> : <Menu size={20} />}
    </button>
  );
}
